var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import css from '@styled-system/css';
import { themeGet } from '@styled-system/theme-get';
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { alignSelf, border, color, compose, layout, space } from 'styled-system';
import Box from './Box';
import theme from '../theme';
function iconStyles(props) {
    return css({
        pl: props.before && '2',
        pr: props.after && '2'
    });
}
function boxStyles(props) {
    const boxSize = props.boxSize || 'medium';
    const boxTypes = {
        large: {
            width: '250px',
            padding: '3'
        },
        medium: {
            width: '200px',
            padding: '2'
        },
        small: {
            width: '150px',
            padding: '1'
        }
    };
    return css(boxTypes[boxSize]);
}
function textStyles(props) {
    const boxSize = props.boxSize || 'medium';
    const textTypes = {
        large: {
            fontSize: '1'
        },
        medium: {
            fontSize: '0'
        },
        small: {
            fontSize: '12px'
        }
    };
    return css(textTypes[boxSize]);
}
function disabledStyles(props) {
    if (!props.disabled) {
        return;
    }
    return css({
        bg: 'gray.5',
        color: 'gray.3',
        cursor: 'not-allowed'
    });
}
function focusedStyles(props) {
    if (!props.focus) {
        return;
    }
    return css({
        boxShadow: `0 0 1px 1px ${themeGet('colors.gray.2', 'lightgray')(props)}`,
        borderColor: 'gray.2',
        borderStyle: 'solid',
        borderWidth: '1',
        outline: '0'
    });
}
const InputBox = styled(Box) `
  ${css({
    alignItems: 'center',
    borderColor: 'gray.3',
    borderRadius: '1',
    borderStyle: 'solid',
    borderWidth: '1',
    color: 'gray.0',
    flexDirection: 'row',
    fontFamily: 'body',
    fontSize: 0,
    fontWeight: 'light'
})}
  ${boxStyles}
  ${disabledStyles}
  ${focusedStyles}
  ${iconStyles}
  ${compose(alignSelf, color, border, layout, space)}
`;
const StyledIcon = styled.div `
  ${({ position }) => css({
    pr: position === 'before' ? '2' : '1',
    pl: position === 'after' ? '2' : '1'
})}
`;
const StyledInput = styled.input `
  ${css({
    outline: '0',
    border: 'none',
    bg: 'transparent',
    fontFamily: 'body',
    fontWeight: 'light',
    padding: '0',
    width: '100%'
})}
  ${textStyles}
  &::placeholder {
    ${css({
    color: 'gray.3',
    opacity: '1' // for mozilla inputs
})}
  }
  &:-webkit-autofill,
  &:-webkit-autofill::first-line,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    ${css({
    fontFamily: 'body',
    fontSize: '0'
})}
  }
  &:disabled {
    ${css({
    bg: 'gray.5',
    cursor: 'not-allowed'
})}
  }
`;
const Input = forwardRef((_a, ref) => {
    var { id, name, value, defaultValue, onChange, placeholder, before, after, disabled, maxLength, max, min, minLength, boxSize, step, theme, type } = _a, rest = __rest(_a, ["id", "name", "value", "defaultValue", "onChange", "placeholder", "before", "after", "disabled", "maxLength", "max", "min", "minLength", "boxSize", "step", "theme", "type"]);
    const [focus, setFocus] = useState(false);
    return (React.createElement(InputBox, Object.assign({ focus: focus, theme: theme, before: before, after: after, disabled: disabled, boxSize: boxSize }, rest),
        before && React.createElement(StyledIcon, { position: 'before' }, before),
        React.createElement(StyledInput, { id: id, name: name, value: value, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, disabled: disabled, ref: ref, maxLength: maxLength, max: max, min: min, minLength: minLength, step: step, type: type, theme: theme, onFocus: () => setFocus(true), onBlur: () => setFocus(false), boxSize: boxSize }),
        after && React.createElement(StyledIcon, { position: 'after' }, after)));
});
Input.defaultProps = { theme };
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=Input.js.map